module.exports = __webpack_public_path__ + "static/media/twitter.b461c8e7.svg";